import { requestJson } from '../../../shared/api/http'
import type { ContactSubmission, ContactSubmissionResponse } from '../model/contact'

export async function submitContactForm(
  payload: ContactSubmission,
  signal?: AbortSignal,
): Promise<ContactSubmissionResponse> {
  return requestJson<ContactSubmissionResponse>('/api/v1/contact', {
    method: 'POST',
    body: JSON.stringify(payload),
    signal,
  })
}
